module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_pomodoro_circle.bec00048.svg";